<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">業態別企画設定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">受注コード</label>
              <div class="list-input-content">
                <app-order-code-text-input id="txti_OrderCode" #txti_OrderCode [subid]="'txti_OrderCode'"
                  [catalogIDField]="txi_DelivCatalog" [autofocus]="true" [required]="true" [tabindex]="0"
                  [forcedEnabledMode]="'true'" [(ngModel)]="this.kymw0902Model.orderCode"
                  (ngModelChange)="eventOrderCodeChangedHandler()">
                </app-order-code-text-input>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title">配達企画回（翌週）</label>
              <div class="list-input-content">
                <input type="text" class="deliv-catalog" id="txi_DelivCatalog" #txi_DelivCatalog readonly>
              </div>
            </div>
          </div>
          <button id="btn_searchGoods" class="btn-secondary" #btn_searchGoods [tabindex]="0"
              forcedEnabledMode="none" (click)="eventSearchGoods_CLICKHandler()">商品検索</button>
        </div>
        <div>
          <h1>業態別企画商品一覧</h1>
          <div class="column-list">
            <label class="list-input-title">デイリー</label>
            <div class="list-input-content">
              <app-code-combo-box [blank]="false" id="cmb_DutiesFormDailyDiv" #cmb_DutiesFormDailyDiv
                [subid]="'cmb_DutiesFormDailyDiv'" [codeDiv]="'ctp123'" [labelField]="'codeValueName'" [tabindex]="0"
                [forcedEnabledMode]="''" [(ngModel)]="this.kymw0902Model.dutiesFormDailyDiv">
              </app-code-combo-box>
              <button id="btn_Reflection" class="btn-secondary" #btn_Reflection [tabindex]="0" forcedEnabledMode=""
                (click)="eventDivAppointname_CLICKHandler(null)">指定</button>
            </div>
          </div>
          <div class="action-area">
            <div class="element-row">
              <button id="btn_AllSelect" class="btn-tartiary" #btn_AllSelect [tabindex]="0" forcedEnabledMode=""
                (click)="eventAllCheck_CLICKHandler(null)">全選択</button>
              <button id="btn_AllUnSelect" class="btn-tartiary" #btn_AllUnSelect [tabindex]="0" forcedEnabledMode=""
                (click)="eventAllUnCheck_CLICKHandler(null)">全解除</button>
              <app-pager [prevDisabled]="!kymw0902Model.activeBtnBack" [nextDisabled]="!kymw0902Model.activeBtnNext"
                [totalNum]="kymw0902Model.totalNum" [startNum]="kymw0902Model.startDispNum"
                [endNum]="kymw0902Model.endDispNum" (prevHandler)="eventBack_CLICKHandler(null)"
                (nextHandler)="eventNext_CLICKHandler(null)">
              </app-pager>
            </div>
          </div>
          <wj-flex-grid #dtg_PlanGoodsList [style.width.px]="1154" [style.height.px]="615"
            id="dtg_PlanGoodsList" [tabindex]="0" [itemsSource]="this.kymw0902Model.planGoodsList"
            [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'"
            [allowResizing]="'Columns'" (click)="eventDtgPlanGoodsList_HEADERRELEASEHandler($event,dtg_PlanGoodsList)"
            [isReadOnly]="true">
            <wj-flex-grid-column [minWidth]="5" [header]="'選択'" [binding]="'Selected'" rendererIsEditor="true"
              sortable="false" [width]="45" [isReadOnly]="false" [align]="'center'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <input type="checkbox" [(ngModel)]="cell.item.Selected" [tabindex]="-1"
                  id="cb_plan_goods_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'部門'" [binding]="'ClassCodeName'" [width]="100"
              [isReadOnly]="true">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'小分類'" [binding]="'SmallClassCodeName'" [width]="200"
              [isReadOnly]="true">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [binding]="'GuideGoodsName'" [width]="300"
              [isReadOnly]="true">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [binding]="'GuideStandardName'" [width]="300"
              [isReadOnly]="true">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'い'" [binding]="'HandlingCoop1'" [width]="50"
              [isReadOnly]="true" [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'と'" [binding]="'HandlingCoop2'" [width]="50"
              [isReadOnly]="true" [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'ぐ'" [binding]="'HandlingCoop3'" [width]="50"
              [isReadOnly]="true" [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'ち'" [binding]="'HandlingCoop4'" [width]="50"
              [isReadOnly]="true" [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'さ'" [binding]="'HandlingCoop5'" [width]="50"
              [isReadOnly]="true" [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'とう'" [binding]="'HandlingCoop6'" [width]="50"
              [isReadOnly]="true" [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'な'" [binding]="'HandlingCoop7'" [width]="50"
              [isReadOnly]="true" [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'に'" [binding]="'HandlingCoop8'" [width]="50"
              [isReadOnly]="true" [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'ク'" [binding]="'HandlingCoop9'" [width]="50"
              [isReadOnly]="true" [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [binding]="'Pcode'" [width]="90" [isReadOnly]="true"
              [align]="'left'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'デイリー'" [binding]="'DutiesFormDailyDivName'" [width]="120"
              [isReadOnly]="true">
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Cancel" class="btn-tartiary warning" #btn_Cancel [tabindex]="0" forcedEnabledMode=""
            (click)="eventClear_CLICKHandler(null)">取消</button>
          <button id="btn_Update" class="btn-primary" #btn_Update [tabindex]="0" forcedEnabledMode=""
            (click)="eventStatusUpdate_CLICKHandler(null)">更新</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler(null)"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>